export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/ob-step-11.png?eb047bdf912107b40599bfe8bbddf7ab";